import { render, staticRenderFns } from "./CurrentStock.vue?vue&type=template&id=2465890f&scoped=true"
import script from "./CurrentStock.vue?vue&type=script&lang=js"
export * from "./CurrentStock.vue?vue&type=script&lang=js"
import style0 from "./CurrentStock.vue?vue&type=style&index=0&id=2465890f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2465890f",
  null
  
)

export default component.exports